import { useTranslation } from "react-i18next";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export function PerformanceSkeleton<M extends string>({
  defaultSlots,
  size,
}: {
  defaultSlots: readonly M[];
  size: "compact" | "default";
}) {
  const { t } = useTranslation("campaign");
  return (
    <div role="status" aria-label={t("performance.loadingAria")} className="animate-pulse">
      <div className="grid grid-cols-3 border-b border-line min-[1440px]:grid-cols-6">
        {defaultSlots.map((key, index) => (
          <div
            key={key}
            className={cn(
              "border-line p-4",
              size === "default" ? "h-28" : "h-[94px]",
              index % 3 !== 2 && "max-[1439px]:border-r",
              index < defaultSlots.length - 3 && "max-[1439px]:border-b",
              index % 6 !== 5 && index < defaultSlots.length - 1 && "min-[1440px]:border-r",
            )}
          >
            <Skeleton className={cn("w-16", size === "default" ? "h-3" : "h-2.5")} />
            <Skeleton className={cn("mt-2 w-24", size === "default" ? "h-7" : "h-6")} />
            <Skeleton className={cn("mt-2 w-28", size === "default" ? "h-3" : "h-2.5")} />
          </div>
        ))}
      </div>
      <div className="h-[360px] p-4">
        <Skeleton className="h-full w-full rounded-[8px]" />
      </div>
    </div>
  );
}
